import { render, staticRenderFns } from "./RuleAccommodationsForm.vue?vue&type=template&id=3deb4ef5&"
import script from "./RuleAccommodationsForm.vue?vue&type=script&lang=js&"
export * from "./RuleAccommodationsForm.vue?vue&type=script&lang=js&"
import style0 from "./RuleAccommodationsForm.vue?vue&type=style&index=0&id=3deb4ef5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports